import LocalizedStrings from 'localized-strings';

import { ShineRecurringAccountingExportSettingsCadence } from '__generated__/GQL';

/**
 * @todo Validate locales
 * @see https://linear.app/shine/issue/CAC-1053
 */
const locales = new LocalizedStrings({
  en: {
    cadence: {
      [ShineRecurringAccountingExportSettingsCadence.Monthly]: 'Mois',
    },
    description: 'Votre export sera envoyé le {date} de chaque mois',
    each: 'tous les',
    sendOn: 'Envoyer le',
    title: 'Fréquence',
  },
  fr: {
    cadence: {
      [ShineRecurringAccountingExportSettingsCadence.Monthly]: 'Mois',
    },
    description: 'Votre export sera envoyé le {date} de chaque mois',
    each: 'tous les',
    sendOn: 'Envoyer le',
    title: 'Fréquence',
  },
} as const);

export default locales;
